<script>
  import { onMount, createEventDispatcher } from "svelte";
  let dispatch = createEventDispatcher();
  import { Username, changePasswordThrough, FromPage } from "./store.js";

  onMount(async function() {
    if ($Username.value == '')
      dispatch("pageChange", "/account/login");
  });
</script>

<form action="" class="box">
  {#if $FromPage === 'login'}
    <!-- Login entry: no password reset was performed — the user keeps the
         credentials they just signed in with. Claiming a password was
         emailed here was wrong (and for staff accounts it named an
         @lgflmail address the reset never even went to). -->
    <h1 class="title is-5">Account Set Up</h1>
      <p>The account for <strong>{$Username.value}</strong> is now set up for eAdmissions.</p>
      <p>Your username and password have not changed — please sign in with the details you just used.</p>
    <div style="text-align: right; margin-top: 15px;">
      <a href="/signin/{$Username.value}/" class="button is-purple">Login to eAdmissions</a>
    </div>
  {:else}
    <h1 class="title is-5">Account Restoration</h1>
      <p>The Account for <strong>{$Username.value}</strong> has been successfully restored. </p>
      <p>For security reaons, your password has been updated and sent to you via <strong>{$changePasswordThrough}</strong>.</p>
      <p>You can now log in to continue using eAdmissions.
    </p>
    <div style="text-align: right; margin-top: 15px;">
      <a href="/signin/{$Username.value}/" class="button is-purple">Login to eAdmissions</a>
    </div>
  {/if}
</form>